import React, { useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Chip, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Col, Row } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";

const FranchTable = ({
  franchise,
  onSelectFranchise,
  onEdit,
  onDelete,
  handleAddForm,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  onReset,
  onExport,
  handleFilterFranchisee,
  handleOpenSuspend,
}) => {
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedFranchDelete, setSelectedFranchDelete] = useState(null);

  const handleDeleteClick = (service) => {
    setShowDeletePopup(true);
    setSelectedFranchDelete(service);
  };
  const confirmDelete = () => {
    if (selectedFranchDelete) {
      onDelete(selectedFranchDelete.id);
      setSelectedFranchDelete(null);
    }
  };

  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredFranchisee = franchise.filter(
    (franchisee) =>
      franchisee.business_title
        .toLowerCase()
        .includes(searchValue.toLocaleLowerCase()) ||
      franchisee.place.toLowerCase().includes(searchValue.toLocaleLowerCase())
  );

  const displayFranchisee = searchValue ? filteredFranchisee : franchise;
  const franchiseeWithIndex = displayFranchisee.map((payment, index) => ({
    ...payment,
    displayIndex: index + 1,
  }));
  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "Business ID", width: 120 },
    { field: "business_title", headerName: "Franchise Name", width: 200 },
    { field: "place", headerName: "Place", width: 150 },
    { field: "total_booking", headerName: "Total Booking", width: 150 },
    {
      field: "total_completed_booking",
      headerName: "Total Completed Booking",
      width: 200,
    },
    {
      field: "total_waiting_booking",
      headerName: "Total Waiting Booking",
      width: 200,
    },
    {
      field: "total_canceled_booking",
      headerName: "Total Cancelled Booking",
      width: 200,
    },
    { field: "total_amount", headerName: "Total Amount", width: 150 },
    {
      field: "business_is_active",
      headerName: "Franchisee Status",
      width: 150,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          style={{
            backgroundColor: params.value ? "green" : "red",
            color: "white",
          }}
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 280,
      sortable: false,
      renderCell: (params) => (
        <div className="action-btn">
          <Button
            variant="outlined"
            color="success"
            style={{ marginRight: "5px" }}
            onClick={(event) => {
              event.stopPropagation();
              onSelectFranchise(params.row);
            }}
          >
            <VisibilityIcon />
          </Button>
          <Button
            variant="outlined"
            color="primary"
            style={{ marginRight: "5px" }}
            onClick={(event) => {
              event.stopPropagation();
              onEdit(params);
            }}
          >
            <EditIcon />
          </Button>
          <Button
            variant="outlined"
            color={params.row.business_is_active ? "error" : "success"}
            style={{ marginRight: "5px" }}
            onClick={(event) => {
              event.stopPropagation();
              handleOpenSuspend(params.row.id);
            }}
          >
            {params.row.business_is_active ? "Deactive" : "Active"}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Row className="my-2">
        <Col>
          <div className="search-container d-flex justify-content-center my-2">
            <TextField
              id="search"
              name="search"
              className="search-field"
              placeholder="Search here..."
              value={searchValue}
              onChange={handleSearchChange}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "transparent" },
                  "&:hover fieldset": { borderColor: "transparent" },
                  "&.Mui-focused fieldset": { borderColor: "transparent" },
                },
              }}
            />
          </div>
        </Col>
        <Col>
          <div>
            <div className="download-excel mt-2">
              <div className="date-picker">
                <input
                  className="date-input"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  placeholder="Start Date"
                />
                <div className="range">-</div>
                <input
                  className="date-input"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  placeholder="End Date"
                  min={startDate}
                />
              </div>
              <div className="date-picker-btns">
                <button
                  className="filter-btn"
                  onClick={() => handleFilterFranchisee()}
                >
                  Apply Range
                </button>
                <button className="reset-btn" onClick={onReset}>
                  Reset
                </button>
                <Button variant="contained" color="primary" onClick={onExport}>
                  <DownloadIcon /> Download
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <button className="btn-add-franch" onClick={handleAddForm}>
        Add Franchisee Details
      </button>
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 682, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <DataGrid
          rows={franchiseeWithIndex}
          columns={columns}
          disableSelectionOnClick
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          onRowClick={(params) => onSelectFranchise(params.row)}
        />
      </Box>
      {selectedFranchDelete && (
        <Dialog
          open={showDeletePopup}
          onClose={() => setShowDeletePopup(false)}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Do you really want to delete?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              size="small"
              color="error"
              style={{ textTransform: "none" }}
              onClick={confirmDelete}
            >
              Delete
            </Button>
            <Button
              size="small"
              style={{
                textTransform: "none",
                color: "grey",
                outline: "1px solid grey",
              }}
              onClick={() => setShowDeletePopup(false)}
            >
              cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default FranchTable;
